import UnvalidateOwnerScreen from './model'
export default UnvalidateOwnerScreen